import "@fontsource/inter";

import "./styles/rsuite-customized.less";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./utils/rpc";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <Router>
        <StrictMode>
            <App />
        </StrictMode>
    </Router>,
);
